export const HVAC_MODE = {
  AUTO: { key: 'auto', label: 'Auto' },
  COOL_ONLY: { key: 'cool-only', label: 'Cool Only' },
  HEAT_ONLY: { key: 'heat-only', label: 'Heat Only' },
  FAN_ONLY: { key: 'fan-only', label: 'Fan Only' },
};

export const STATUS_CSS = {
  HEALTHY: 'healthy',
  WARN: 'warn',
  UNHEALTHY: 'unhealthy',
  OFFLINE: 'offline',
  UNMANAGED: 'unmanaged',
  OVERRIDDEN: 'overridden',
};

export const THERMAL_ZONE_STATUS = {
  VERY_OUT_OF_RANGE: {
    key: 'very-out-of-range',
    label: 'Very out of Range',
    cssClass: STATUS_CSS.UNHEALTHY,
  },
  OUT_OF_RANGE: { key: 'out-of-range', label: 'Out of Range', cssClass: STATUS_CSS.WARN },
  HEAT_BLOCKED: {
    key: 'heat-blocked',
    label: 'Low (Heat Blocked)',
    cssClass: STATUS_CSS.OVERRIDDEN,
  },
  COOL_BLOCKED: {
    key: 'cool-blocked',
    label: 'High (Cool Blocked)',
    cssClass: STATUS_CSS.OVERRIDDEN,
  },
  IN_OVERRIDE: {
    key: 'in-override',
    label: 'In Override',
    cssClass: STATUS_CSS.OVERRIDDEN,
  },
  IN_RANGE: { key: 'in-range', label: 'In Range', cssClass: STATUS_CSS.HEALTHY },
  OFFLINE: { key: 'offline', label: 'Offline', cssClass: STATUS_CSS.OFFLINE },
  UNMANAGED: { key: 'unmanaged', label: 'Unmanaged', cssClass: STATUS_CSS.UNMANAGED },
};
